/**
 * Extracted from angular-bootstrap-ui 0.8.0
 */
define([
    './TabsetCtrl',

    './directives/Tabset',
    './directives/Tab',
    './directives/TabHeading',
    './directives/TabContent'
], (TabsetCtrl, TabsetDirective, TabDirective, TabHeadingDirective, TabContentDirective)=> {
    angular.module('edge.platform.widgets.tabs', [])
        .controller('TabsetController', TabsetCtrl)
        .directive('tabset', TabsetDirective)
        .directive('tab', TabDirective)
        .directive('tabHeadingTransclude', TabHeadingDirective)
        .directive('tabContentTransclude', TabContentDirective);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/tabs/module.js
 **/